// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__3RxDL","loader":"Spinner_loader__3CNEt","load8":"Spinner_load8__2KtVB"};